import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalizedNav } from '../i18n/useLocalizedNav';

const Footer = () => {
  const { t } = useTranslation();
  const { navigate } = useLocalizedNav();

  const styles = {
    footer: {
      backgroundColor: '#093670ff',
      color: '#ffffff',
      padding: '60px 20px 20px',
    },
    footerContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    footerGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '40px',
      marginBottom: '40px',
    },
    footerTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      marginBottom: '15px',
    },
    footerText: {
      color: '#9ca3af',
      fontSize: '14px',
    },
    footerSubtitle: {
      fontSize: '16px',
      fontWeight: 'bold',
      marginBottom: '15px',
      textAlign: 'left',
    },
    footerList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      textAlign: 'left',
    },
    footerListItem: {
      marginBottom: '10px',
      color: '#9ca3af',
      fontSize: '14px',
      textAlign: 'left',
    },
    footerLink: {
      background: 'none',
      border: 'none',
      color: '#9ca3af',
      cursor: 'pointer',
      padding: 0,
      fontSize: '14px',
      transition: 'color 0.3s',
      textAlign: 'left',
    },
    copyright: {
      borderTop: '1px solid #374151',
      paddingTop: '30px',
      textAlign: 'center',
      color: '#9ca3af',
      fontSize: '14px',
    },
  };

  // グループ会社・店舗の実名。全言語で共通のため翻訳リソースには入れない。
  const companyLinks = [
    '株式会社メビウス',
    'アスティルホテル新大阪',
    'アスティルホテル十三',
    'オアシスサウナ アスティル',
    '立呑処新橋へそ 南森町店',
    '立呑処新橋へそ 京都駅前店',
    '天ぷら割鮮酒処へそ 京都店',
    'メビウス リネン工場',
    'Fuca Fuca 三国1号店',
    'Fuca Fuca 彦根店',
    'カーウォッシュビックディッパー',
    'パチンコホール',
  ];

  return (
    <footer style={styles.footer}>
      <style>
        {`
          @media (max-width: 768px) {
            .footer-grid-mobile {
              grid-template-columns: 1fr !important;
              gap: 30px !important;
            }
            .footer-logo-mobile {
              height: 60px !important;
            }
            .footer-logo-second-mobile {
              height: 80px !important;
            }
          }
        `}
      </style>
      <div style={styles.footerContainer}>
        <div style={styles.footerGrid} className="footer-grid-mobile">
          <div>
            <img 
              src="/jtclogo.png" 
              alt="Japan Tabibito Club" 
              style={{height: '80px', width: 'auto', marginBottom: '15px'}}
              className="footer-logo-mobile"
            />
            <p style={styles.footerText}>{t('footer.tagline')}</p>
            <img 
              src="/tabibitologo.png" 
              alt="Japan Tabibito Club" 
              style={{height: '100px', width: 'auto', marginTop: '15px'}}
              className="footer-logo-second-mobile"
            />
          </div>

          <div>
            <h4 style={styles.footerSubtitle}>LINKS</h4>
            <ul style={styles.footerList}>
              <li style={styles.footerListItem}>
                <button onClick={() => navigate('/')} style={styles.footerLink}>{t('footer.home')}</button>
              </li>
              <li style={styles.footerListItem}>
                <button onClick={() => navigate('/about')} style={styles.footerLink}>{t('footer.about')}</button>
              </li>
              <li style={styles.footerListItem}>
                <button onClick={() => navigate('/news')} style={styles.footerLink}>{t('footer.news')}</button>
              </li>
              <li style={styles.footerListItem}>
                <a
                  href="https://web.ayubito.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ ...styles.footerLink, textDecoration: 'none', display: 'inline-block' }}
                >
                  {t('footer.ayubitoLink')}
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 style={styles.footerSubtitle}>{t('footer.groupTitle')}</h4>
            <ul style={styles.footerList}>
              {companyLinks.map((company, index) => (
                <li key={index} style={styles.footerListItem}>
                  <p>
                    {company}
                  </p>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 style={styles.footerSubtitle}>CONTACT</h4>
            <ul style={styles.footerList}>
              <li style={styles.footerListItem}>{t('footer.tel')}</li>
              <li style={styles.footerListItem}>{t('footer.address')}</li>
            </ul>
          </div>
        </div>
        <div style={styles.copyright}>
          <p>&copy; {new Date().getFullYear()} {t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;